import { render, staticRenderFns } from "./transfer-modal.vue?vue&type=template&id=fb4f56a0&scoped=true&"
import script from "./transfer-modal.vue?vue&type=script&lang=js&"
export * from "./transfer-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4f56a0",
  null
  
)

export default component.exports